import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronRight, Loader2 } from "lucide-react";
import { ReactQueryErrorWrapper } from "components/shared/react-query-error-wrapper";
import { Attribute } from "../../models";
import { useClipProducts } from "../../catalogue/use-clip-products";
import {
  filterCatalogue,
  groupByCategory,
} from "../../catalogue/catalogue-utils";
import { AttributeTree } from "../step-2-choose-data/attribute-tree";

interface DataTreeProps {
  selected: Attribute[];
}

export const DataTree = (props: DataTreeProps) => {
  const productsQuery = useClipProducts();
  const catalogue = productsQuery.data ?? [];
  const grouped = groupByCategory(filterCatalogue(catalogue, "", "All")).map(
    (group) => ({
      ...group,
      products: group.products.filter((product) =>
        props.selected.some(
          (selected) =>
            selected.key === product.productKey &&
            selected.attributes.length > 0,
        ),
      ),
    }),
  );

  return (
    <div className="flex flex-col gap-1">
      {productsQuery.isLoading && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground py-2">
          <Loader2 className="size-4 animate-spin" />
          Loading products…
        </div>
      )}
      <ReactQueryErrorWrapper queries={[productsQuery]} />
      {!productsQuery.isLoading &&
        !productsQuery.isError &&
        grouped.every((group) => group.products.length === 0) && (
          <p className="text-sm text-muted-foreground py-2">
            No data selected.
          </p>
        )}
      {grouped.map(
        (group) =>
          group.products.length > 0 && (
            <Collapsible key={group.category} defaultOpen>
              <CollapsibleTrigger className="flex items-center gap-1 py-1 text-sm font-medium w-full hover:bg-accent/50 rounded px-1 [&[data-state=open]>svg]:rotate-90">
                <ChevronRight className="size-4 transition-transform" />
                {group.category}
                <span className="text-xs text-muted-foreground">
                  ({group.products.length})
                </span>
              </CollapsibleTrigger>
              <CollapsibleContent>
                <AttributeTree
                  products={group.products}
                  catalogue={catalogue}
                  selected={props.selected}
                  search=""
                  readOnly
                  onToggleProduct={() => undefined}
                  onToggleLayer={() => undefined}
                  onToggleGroup={() => undefined}
                />
              </CollapsibleContent>
            </Collapsible>
          ),
      )}
    </div>
  );
};
